// Work tab health, derived server-side from a close's current stage and
// delivery date. NONE covers finished/cancelled closes and closes with no
// due date to judge by.
export enum CloseHealth {
    AT_RISK = "at_risk",
    WATCHING = "watching",
    ON_TRACK = "on_track",
    NONE = "none",
}

export const closeHealthLabels: Record<CloseHealth, string> = {
    [CloseHealth.AT_RISK]: "At risk",
    [CloseHealth.WATCHING]: "Watching",
    [CloseHealth.ON_TRACK]: "On track",
    [CloseHealth.NONE]: "No health",
};

// Worst first. NONE has no rank so it sorts last in both directions.
export const closeHealthRank: Record<CloseHealth, number | null> = {
    [CloseHealth.AT_RISK]: 0,
    [CloseHealth.WATCHING]: 1,
    [CloseHealth.ON_TRACK]: 2,
    [CloseHealth.NONE]: null,
};

// Why a close has its health. Null for NONE, which the Work tab leaves blank.
export enum CloseHealthReason {
    DELIVERY_DATE_PASSED = "delivery_date_passed",
    STAGE_TASKS_OVERDUE = "stage_tasks_overdue",
    STAGE_TASKS_DUE_TODAY = "stage_tasks_due_today",
    STAGE_TASKS_DUE_LATER = "stage_tasks_due_later",
}

export const closeHealthReasonDescriptions: Record<CloseHealthReason, string> =
    {
        [CloseHealthReason.DELIVERY_DATE_PASSED]:
            "The work delivery date has passed and the work isn't finished.",
        [CloseHealthReason.STAGE_TASKS_OVERDUE]:
            "Every open task with a due date in the current stage is overdue.",
        [CloseHealthReason.STAGE_TASKS_DUE_TODAY]:
            "The latest due date among open tasks in the current stage is today.",
        [CloseHealthReason.STAGE_TASKS_DUE_LATER]:
            "The latest due date among open tasks in the current stage is after today.",
    };

export const closeHealthByReason: Record<CloseHealthReason, CloseHealth> = {
    [CloseHealthReason.DELIVERY_DATE_PASSED]: CloseHealth.AT_RISK,
    [CloseHealthReason.STAGE_TASKS_OVERDUE]: CloseHealth.AT_RISK,
    [CloseHealthReason.STAGE_TASKS_DUE_TODAY]: CloseHealth.WATCHING,
    [CloseHealthReason.STAGE_TASKS_DUE_LATER]: CloseHealth.ON_TRACK,
};

export const getCloseHealthFromReason = (
    reason: CloseHealthReason | null,
): CloseHealth =>
    reason === null ? CloseHealth.NONE : closeHealthByReason[reason];
